import { render, staticRenderFns } from "./pause.vue?vue&type=template&id=f89cb16c&scoped=true"
import script from "./pause.vue?vue&type=script&lang=js"
export * from "./pause.vue?vue&type=script&lang=js"
import style0 from "./pause.vue?vue&type=style&index=0&id=f89cb16c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89cb16c",
  null
  
)

export default component.exports